export default "__VITE_ASSET__CYfiqcTW__"